import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonEx } from '@xyo-network/sdk-xyo-react-js';
import logo from './img/logo.svg';
const Logo = (props) => (_jsx(ButtonEx, Object.assign({}, props, { children: _jsx("img", { height: 48, width: 110, alt: "logo", src: logo }, void 0) }), void 0));
export default Logo;
//# sourceMappingURL=Logo.js.map